import dayjs from "dayjs";

export function getMondayAndSaturday(timestamp) {
  const date = dayjs(timestamp);
  const day = date.day();
  const diffMonday = date.date() - day + (day === 0 ? -6 : 1);
  const diffSaturday = date.date() - day + (day === 0 ? 0 : 6);

  const monday = date.date(diffMonday);
  const saturday = date.date(diffSaturday);

  const formattedMonday = monday.format("YYYY-MM-DD");
  const formattedSaturday = saturday.format("YYYY-MM-DD");

  return { monday: formattedMonday, saturday: formattedSaturday };
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/utils/getMondayAndSaturday.js